var $ = require('jquery');

/**
 * Simple scroll controller
 */
    var ScrollControl = module.exports = function(){
        var t = this;
        t.$document = $(document);
    };
    ScrollControl.prototype = {
        init: function(){
            var t = this;
            $(t).trigger({
                type: "onInit",
                originalEvent: null
            })
            t._bindEvents();
        },
        _bindEvents: function(){
            var t = this;

            $(window).scroll(function (e) {
                $(t).trigger({
                    type: "onScroll",
                    originalEvent: e
                })
            });
        } ,
        /**
         * @return {Number} px of the top position of viewport
         */
        getScrollTop: function(){
            var t = this;
            return t.$document.scrollTop();
        }
    }


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/ScrollControl.js